import * as $ from "jquery";
import moment from "moment";
import Component from "vue-class-component";
import { Location } from "vue-router/types/router";
import { ContratACalculerDto } from "../../dto/GenApi.iNotPaie.Dto/ContratACalculerDto";
import { LigneBulletinDto } from "../../dto/GenApi.iNotPaie.Dto/LigneBulletinDto";
import { NavigationData } from "../../shared/services/navigation.service";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalArretSurImage from "./modalArretSurImage/modalArretSurImage";
import ModalEditionBulletins from "./modalEditionBulletins/modalEditionBulletins";

interface columnStyle {
	name: string,
	width: number
}

@Component({
	components: {
		ModalEditionBulletins: require("./modalEditionBulletins/modalEditionBulletins.vue.html"),
		ModalArretSurImage: require("./modalArretSurImage/modalArretSurImage.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as CalculDePaieComponent);
			vm.fetchData();
			vm.isAdministrateur = ParametresInstance.userHasRole(RoleConstants.Administrateur);
		});
	}
})
export default class CalculDePaieComponent extends VueBase {
	public salaries: ContratACalculerDto[] = [];
	public salariesFiltred: ContratACalculerDto[] = [];
	public contratSelectionne: ContratACalculerDto | undefined;
	public curentOrberColumn = "FullName";
	public orderingDesc = true;
	public colorCache: string[] = ["#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"];
	public dataReady = false;
	public loadingMessage = "Chargement";
	public filterName = "";
	public arretSurImage = false;
	public codeRubrique = "";
	public isAdministrateur = false;
	public currentData?: Blob = undefined;
	public currentDataUrl?: string = undefined;
	public listBulletinDejaCharge: (Blob | undefined)[] = [];
	public lignesBulletin: LigneBulletinDto[] = [];
	public allSelected = false;
	public lastEchelle: any = {}
	public disableClose = false;
	public modalArretSurImage?: ModalArretSurImage = undefined;
	public modalEditionBulletins?: ModalEditionBulletins = undefined;
	public listColonnes: columnStyle[] = [
		{ name: "Numero", width: 100 },
		{ name: "NumeroContrat", width: 100 },
		{ name: "FullName", width: 150 },
		{ name: "Qualification", width: 100 },
		{ name: "DateEntree", width: 100 },
		{ name: "TypeContrat", width: 100 },
		{ name: "Indicateurs", width: 100 },
		{ name: "Bulletin", width: 100 },
		{ name: "Regime", width: 100 }];

	public getTableWidth(): any {
		let widthTable = 8;
		for (let i = 0; i < this.listColonnes.length; i++) {
			widthTable += this.listColonnes[i].width;
		}

		return {
			width: widthTable + "px"
		};
	}

	public click_check(target: any): void {
		const element: HTMLElement = document.getElementById(target) as HTMLElement;
		element.click();
	}

	public getSizeEchelle(): any {
		const listeContainer: any = this.$refs.listeSalarieBodyCard;

		if (listeContainer != undefined && listeContainer.clientHeight != undefined) {
			const hauteurEchelle = Number(listeContainer.clientHeight) - 70;
			this.lastEchelle = {
				height: hauteurEchelle + "px"
			};

			return {
				height: hauteurEchelle + "px"
			};
		} else {
			return this.lastEchelle;
		}
	}

	public getVisibility(columnName: string): any {
		const style = this.listColonnes.filter(c => c.name == columnName)[0];

		return { width: style.width + "px" };
	}

	public getVisibilityLigne(id: number): any {
		if (this.contratSelectionne !== undefined &&
			this.contratSelectionne !== null &&
			this.contratSelectionne.IdContrat === id) {
			return { width: "45px !important;", backgroundColor: "#b1cdf7" };
		} else {
			return { width: "45px !important;" };
		}
	}

	public allSelectedChanged(): void {
		for (let i = 0; i < this.salariesFiltred.length; i++) {
			const c: any = this.salariesFiltred[i];
			c.selected = this.allSelected;
		}
		this.$forceUpdate();
	}

	public checkIsModified(route: Location): boolean {
		return super.checkIsModified(route);
	}

	public fetchData(): void {
		this.dataReady = false;
		this.loadingMessage = "Chargement";

		ServicesFactoryInstance.CalculPaieService.GetContratACalculer(data => {
			this.salaries = data;
			this.doFilter();
			this.allSelected = false;

			// On réaffecte le contrat à sélectionner si on le retrouve toujours dans la liste.
			let contratASelectionner: ContratACalculerDto | undefined;
			if (this.contratSelectionne !== undefined && this.contratSelectionne !== null) {
				const contratsFiltresSurId = this.salariesFiltred.filter(s => s.IdContrat === this.contratSelectionne?.IdContrat);
				if (contratsFiltresSurId.length > 0) {
					// Le contrat a été retrouvé.
					contratASelectionner = contratsFiltresSurId[0];
				}
			}
			
			this.dataReady = true;

			// On force la réinitialisation du contrat sélectionné pour prendre en compte les maj éventuelles suite au relaod.
			this.contratSelectionne = undefined;
			this.selectContrat(contratASelectionner);
			this.$forceUpdate();
		}, () => {
			this.dataReady = true;
		});
	}

	public closeToolTips(): void {
		if (this.disableClose) {
			this.disableClose = false;

			return;
		}
		for (let i = 0; i < this.salaries.length; i++) {
			const salarie: any = this.salaries[i];
			salarie.seenTooltip = false;
		}
		this.$forceUpdate();
	}

	public openToolTips(idContrat: any): void {
		this.closeToolTips();
		this.disableClose = true;
		for (let i = 0; i < this.salaries.length; i++) {
			const salarie: any = this.salaries[i];
			salarie.seenTooltip = salarie.IdContrat == idContrat;
		}
		this.$forceUpdate();
	}

	public oderBy(columnName: string): void {
		if (this.curentOrberColumn == columnName) {
			this.orderingDesc = !this.orderingDesc;
		} else {
			this.orderingDesc = true;
		}
		this.curentOrberColumn = columnName;
		this.doOrder();
	}

	public doFilter(): void {
		if (this.filterName == undefined || this.filterName == "") {
			this.salariesFiltred = this.salaries;
		} else {
			this.salariesFiltred = this.salaries.filter(s => s.FullName != undefined &&
				(s.FullName.toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0 ||
					(s.Numero != undefined && s.Numero.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
					(s.NumeroContrat != undefined && s.NumeroContrat.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
					(s.Qualification != undefined && s.Qualification.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
					(s.DateEntree != undefined && moment.utc(s.DateEntree).format("DD/MM/YYYY").toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
					(s.TypeContrat != undefined && s.TypeContrat.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0)));
		}
		this.doOrder();
	}

	public doOrder(): void {
		if (this.salariesFiltred != undefined) {
			this.salariesFiltred.sort(this.sortFunction);
		}
	}

	public sortFunction(a: any, b: any): number {
		if (a[this.curentOrberColumn] < b[this.curentOrberColumn]) {
			return (this.orderingDesc ? -1 : 1);
		}
		if (a[this.curentOrberColumn] > b[this.curentOrberColumn]) {
			return (this.orderingDesc ? 1 : -1);
		}

		return 0;
	}

	public openSalarie(idSalarie: any, titre: string): void {
		EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: titre } });
	}

	public ajouterVariable(filtre: string): void {
		NavigationData.set("/saisieDesVariables", { filtre });
		EventBus.NavigateTo({ path: "/saisieDesVariables"});
	}

	public ajouterAbsence(id: any, idContrat: any, filtre: string): void {
		EventBus.NavigateTo({
			path: "/planningAbsences",
			query: { employeId: id, contractId: idContrat, action: "AddAbsence", filtre: filtre }
		});
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
		if (columnName == this.curentOrberColumn && this.orderingDesc == desc) {
			return "active";
		}

		return "icons";
	}

	public randomColor(color: string): string {
		const r = () => Math.floor(256 * Math.random());

		return this.colorCache[color] || (this.colorCache[color] = `rgb(${r()}, ${r()}, ${r()})`);
	}

	public selectContrat(contratASelectionner?: ContratACalculerDto): void {
		if (contratASelectionner == null) {
			// Pas de contrat à sélectionner. Réinitialisation des propriétés liées au contrat sélectionné
			this.contratSelectionne = undefined;
			this.currentDataUrl = undefined;
			this.currentData = undefined;

			return;
		}

		if (this.contratSelectionne != null &&
			this.contratSelectionne.IdContrat === contratASelectionner.IdContrat) {
			// Pas de changement.
			return;
		}

		this.contratSelectionne = contratASelectionner;
		this.currentDataUrl = undefined;
		this.currentData = undefined;

		if (!contratASelectionner.PaieDuMoisCalcule) {
			// Le bulletin du contrat sélectionné n'est pas calculé.
			this.$forceUpdate();

			return;
		}

		this.currentData = this.listBulletinDejaCharge[contratASelectionner.IdContrat];
		if (this.currentData !== undefined) {
			// Le bulletin du contrat sélectionné est déjà chargé
			this.currentDataUrl = URL.createObjectURL(this.currentData);
			this.$forceUpdate();

			return;
		}

		// Dans les autres cas, on le charge.
		ServicesFactoryInstance.CalculPaieService.getBulletinMoisCourantPdf(contratASelectionner.IdContrat, data => {
			if (data !== null && data.size > 0) {
				this.listBulletinDejaCharge[contratASelectionner.IdContrat] = data;

				this.currentData = data;
				this.currentDataUrl = URL.createObjectURL(this.currentData);
			}
			this.$forceUpdate();
		});
	}

	public downloadPdf(idContrat: number): void {
		this.currentData = undefined;
		this.currentDataUrl = "";

		const blob = this.listBulletinDejaCharge[idContrat];
		if (blob != null) {
			this.download(blob);
		} else {
			ServicesFactoryInstance.CalculPaieService.getBulletinMoisCourantPdf(idContrat, data => {
				this.listBulletinDejaCharge[idContrat] = data;
				this.download(data);
			});
		}
	}

	public download(r: Blob): void {
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(r, "bulletins de salaire.pdf");
			this.dataReady = true;
		} else {
			this.dataReady = true;

			const link = document.createElement("a");
			document.body.appendChild(link);

			link.href = window.URL.createObjectURL(r);
			link.download = "bulletins de salaire.pdf";
			link.click();
		}
	}

	public onLancerCalculs(): void {
		if (ParametresInstance.societeCourante == undefined) {
			NotificationServiceInstance.SendFailed("Vous n'avez pas sélectionné de société.");

			return;
		}
		if (ParametresInstance.societeCourante.PeriodeActive == undefined) {
			NotificationServiceInstance.SendFailed("Vous n'avez pas de période active.");

			return;
		}

		const listeBulletinsSelectionnes = this.GetListeBulletinsSelectionnes();
		if (listeBulletinsSelectionnes.length == 0) {
			NotificationServiceInstance.SendFailed("Vous n'avez sélectionné aucun salarié.");

			return;
		}

		const idContrats: number[] = [];
		listeBulletinsSelectionnes.forEach(b => idContrats.push(b.IdContrat));
		if (idContrats.length > 1 && this.codeRubrique?.length > 0) {
			NotificationServiceInstance.SendFailed("Vous ne devez sélectionner qu'un seul contrat pour effectuer un calcul de rubrique.");

			return;
		}

		this.dataReady = false;
		this.loadingMessage = "Traitement";

		//Permet de désactiver le bouton "Valider la saisie" dans le bandeau
		this.changeValiderSaisieState(true);

		// On place le focus sur le premier élément de la liste à calculer en prévision de la fin du traitement.
		this.contratSelectionne = listeBulletinsSelectionnes[0];

		if (this.codeRubrique?.length > 0) {
			if (this.modalArretSurImage == undefined) {
				this.modalArretSurImage = this.$refs.modalArretSurImage as ModalArretSurImage;
			}

			this.codeRubrique = this.codeRubrique.toUpperCase();
			ServicesFactoryInstance.CalculPaieService.getDetailCalculRubrique(idContrats[0], this.codeRubrique, (data) => {
				if (data.Details.length == 0) {
					NotificationServiceInstance.SendWarning("La rubrique " + this.codeRubrique + " de l'arret sur image n'a pas été calculée.");
					this.dataReady = true;

					return;
				}

				if (this.modalArretSurImage != undefined) {
					this.modalArretSurImage.Init(data);
				}
				this.codeRubrique = "";
				$("#modalArretSurImage").modal("show");
				this.changeValiderSaisieState(false);
				this.dataReady = true;
			}, () => {
				this.changeValiderSaisieState(false);
				this.dataReady = true;
			});
		} else {
			this.clearBulletinsDejaCharges(idContrats);
			this.LancerCalculBulletins(idContrats, false);
		}
	}

	public LancerCalculBulletins(idContratsACalculer: number[], erreurRencontree: boolean): void {
		if (ParametresInstance.societeCourante == undefined) {
			NotificationServiceInstance.SendFailed("Vous n'avez pas sélectionné de société.");
		} else {
			if (idContratsACalculer.length == 0) {
				this.dataReady = true;
				if (erreurRencontree) {
					NotificationServiceInstance.SendWarning("Le calcul de paie s'est terminé avec des erreurs !");
				} else {
					NotificationServiceInstance.SendSuccess("Le calcul de paie s'est correctement déroulé !");
					EventBus.$emit(EventConstants.UPDATE_CONGES);
				}

				this.changeValiderSaisieState(false);
				this.fetchData();

				return;
			}

			this.dataReady = false;

			let idContratsCalcules: number[] = [];

			if (idContratsACalculer.length > 10) {
				// Plus de 10 contrats restants. On prend les 10 premiers pour les calculer et on les sort de la liste des contrats restants.
				idContratsCalcules = idContratsACalculer.splice(0, 10);
			} else {
				// Il reste moins de 10 contrat, on les prend tous et on purge la liste des contrats restants.
				idContratsCalcules = idContratsACalculer;
				idContratsACalculer = [];
			}

			ServicesFactoryInstance.CalculPaieService.calculerPayes({
				IdSociete: ParametresInstance.societeCourante.Id,
				IdContrats: idContratsCalcules
			}, (response) => {
				if (response.WarningMessage?.length > 0) {
                    const message = `Au moins un salaire brut est négatif. <br> ${response.WarningMessage.join("<br>")} <br> Merci de vérifier que cela n'est pas dû à une erreur.`

                    const modalAlerteAvecCallback: ModalAlerteOptions = new ModalAlerteOptions(
                        {
                            message: message,
                            callBackYes: (): void => {
                            },
                            showDialog: true,
                            title: "Attention"
                        });
                    EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteAvecCallback);
				}
				// Pas d'erreur rencontrée, on poursuit le traitement normalement.
				this.LancerCalculBulletins(idContratsACalculer, erreurRencontree);
			}, () => {
				// Des erreurs ont été rencontrées, on poursuit le traitement en précisant la présence d'une erreur.
				this.LancerCalculBulletins(idContratsACalculer, true);
			});
		}
	}

	public arretSuivant(data: string): void {
		this.codeRubrique = data;
		this.onLancerCalculs();

		if (data.length === 0) {
			$("#modalArretSurImage").modal("hide");
		}
	}

	public onRazCalculs(): void {
		if (ParametresInstance.societeCourante == undefined) {
			return;
		}
		if (ParametresInstance.societeCourante.PeriodeActive == undefined) {
			return;
		}

		const listeBulletinsSelectionnes = this.GetListeBulletinsSelectionnes();
		if (listeBulletinsSelectionnes.length == 0) {
			NotificationServiceInstance.SendFailed("Vous n'avez sélectionné aucun salarié.");
			return;
		}

		this.dataReady = false;
		this.loadingMessage = "Remise à 0";

		const idContrats: number[] = [];
		listeBulletinsSelectionnes.forEach(b => idContrats.push(b.IdContrat));

		this.clearBulletinsDejaCharges(idContrats);

		//Permet de désactiver le bouton "Valider la saisie" dans le bandeau
		this.changeValiderSaisieState(true);

		ServicesFactoryInstance.CalculPaieService.razPayes({
			IdSociete: ParametresInstance.societeCourante.Id,
			IdContrats: idContrats
		}, () => {
			this.changeValiderSaisieState(false);
			this.fetchData();
			EventBus.$emit(EventConstants.UPDATE_CONGES);
		}, () => {
			this.changeValiderSaisieState(false);
			this.dataReady = true;
		});
	}

	public clearBulletinsDejaCharges(idContrats: number[]): void {
		idContrats.forEach(id => {
			if (this.listBulletinDejaCharge[id] != null) {
				this.listBulletinDejaCharge[id] = undefined;
			}
		});
	}

	public imprimer(): void {
		const listeBulletinsSelectionnes = this.GetListeBulletinsSelectionnes();
		if (listeBulletinsSelectionnes.length == 0) {
			NotificationServiceInstance.SendFailed("Vous n'avez sélectionné aucun salarié.");

			return;
		}

		if (this.modalEditionBulletins == undefined) {
			this.modalEditionBulletins = this.$refs.modalEditionBulletins as ModalEditionBulletins;
		}

		this.modalEditionBulletins.Init(listeBulletinsSelectionnes);
		this.allSelected = false;
		this.allSelectedChanged();
		$("#modalEditionBulletins").modal("show");
	}

	public GetListeBulletinsSelectionnes(): ContratACalculerDto[] {
		const listeContratsSalectionnes: ContratACalculerDto[] = [];

		for (let i = 0; i < this.salariesFiltred.length; i++) {
			const salarie: any = this.salariesFiltred[i];
			if (salarie.selected) {
				listeContratsSalectionnes.push(salarie);
			}
		}

		return listeContratsSalectionnes;
	}

	//Permet de changer l'état du bouton "Valider la saisie" dans le bandeau
	private changeValiderSaisieState(disable: boolean): void {
		EventBus.$emit(EventConstants.CHANGE_VALIDER_SAISIE_STATE, disable);
	}
}



// WEBPACK FOOTER //
// ./src/components/calculDePaie/calculDePaie.ts